/*******************************************************
OPEN INJURY ARCHIVE MODAL
Used on the injury archive page for NBA.
********************************************************/

import buildModal from '../../universal/modal-window/build-modal';
import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';

export default async function openInjuryArchiveModal(event) {

    const $button = $(event.currentTarget);
    const { injury, dates } = $button.data();

    try {
        // Build the title
        const modalTitle = `
        <div class="flex-row align-center">
            Search Players
        </div>`;

        // Build the content of the modal
        const modalContent = `
            <div class="modal__scroller">
                <div class="flex-col">
                    <div class="grid" style="min-height: 300px;">
                        <div class="col-12_md-12">
                            <section class="mb-25">
                                <div class="input-wrapper has-simple-clear bg-concrete pad-10-10 mb-0 border" data-clear-class="clear-injury-archive-search">
                                    <input id="injury-archive-search" data-injury=${injury} data-dates=${dates} class="text-input full-width" type="text" placeholder="Search players by last name">
                                </div>
                                <ul class="hide archive-search-results list is-block" style="margin:0px;"></ul>
                            </section>
                        </div>
                    </div>
                </div>
            </div>`;

        // Get the modal window HTML
        const modalHTML = buildModal({
            title    : modalTitle,
            content  : modalContent,
        });

        // Append the modal window to the page
        $('.page').append(modalHTML);
    }
    catch (error) {
        showErrorNotificationBar(error.message || 'We were unable to retrieve that info for you. Please try again.', 3000);
    }

}
